export const validateRequired = (value) => {
  if (!value || value.trim() === '') {
    return 'Este campo é obrigatório';
  }
  return null;
};

export const validateEmail = (value) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (value && !emailRegex.test(value)) {
    return 'Por favor, insira um email válido';
  }
  return null;
};

export const validateMinLength = (minLength) => (value) => {
  if (value && value.length < minLength) {
    return `Este campo deve ter pelo menos ${minLength} caracteres`;
  }
  return null;
};

export const validateMaxLength = (maxLength) => (value) => {
  if (value && value.length > maxLength) {
    return `Este campo deve ter no máximo ${maxLength} caracteres`;
  }
  return null;
};

export const validatePhone = (value) => {
  const phoneRegex = /^\+?[\d\s\-\(\)]{10,}$/;
  if (value && !phoneRegex.test(value)) {
    return 'Por favor, insira um número de telefone válido';
  }
  return null;
};

export const validateUrl = (value) => {
  const urlRegex = /^https?:\/\/.+\..+/;
  if (value && !urlRegex.test(value)) {
    return 'Por favor, insira uma URL válida';
  }
  return null;
};